import { useCallback } from "react";
import { queryKeys } from "../constants/constans";
import { useQuery, useQueryClient } from "react-query";

export default function useInRandom() {
  const queryClient = useQueryClient();
  const { data: inRandom }: any = useQuery(queryKeys.inRandom, () =>
    queryClient.getQueryData(queryKeys.inRandom)
  );
  const setInRandom = useCallback(
    (inRandom: boolean) =>
      queryClient.setQueryData(queryKeys.inRandom, inRandom),
    [queryClient]
  );

  return { inRandom: inRandom || false, setInRandom };
}
